var _path, _rect, _path2, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _rect3, _rect4, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78 388H396V406H78V388Z",
    fill: "url(#paint0_linear_106_368)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M297 296H396V314H297V296Z",
    fill: "url(#paint1_linear_106_368)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M297 213H396V231H297V213Z",
    fill: "url(#paint2_linear_106_368)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M297 254H396V272H297V254Z",
    fill: "url(#paint3_linear_106_368)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78 443H396V461H78V443Z",
    fill: "url(#paint4_linear_106_368)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#FA0F00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.0895 111V41.1818H78.2713C83.6349 41.1818 88.1349 42.1818 91.7713 44.1818C95.4304 46.1818 98.1918 48.9318 100.055 52.4318C101.942 55.9091 102.885 59.8636 102.885 64.2955C102.885 68.7727 101.942 72.75 100.055 76.2273C98.169 79.7045 95.3849 82.4432 91.7031 84.4432C88.0213 86.4205 83.4872 87.4091 78.1009 87.4091H60.7486V77.0114H76.3963C79.5327 77.0114 82.1009 76.4659 84.1009 75.375C86.1009 74.2841 87.5781 72.7841 88.5327 70.875C89.5099 68.9659 89.9986 66.7727 89.9986 64.2955C89.9986 61.8182 89.5099 59.6364 88.5327 57.75C87.5781 55.8636 86.0895 54.3977 84.0668 53.3523C82.0668 52.2841 79.4872 51.75 76.3281 51.75H64.7372V111H52.0895ZM137.53 111H113.871V41.1818H138.007C144.939 41.1818 150.893 42.5795 155.871 45.375C160.871 48.1477 164.712 52.1364 167.393 57.3409C170.075 62.5455 171.416 68.7727 171.416 76.0227C171.416 83.2955 170.064 89.5455 167.359 94.7727C164.678 100 160.803 104.011 155.734 106.807C150.689 109.602 144.621 111 137.53 111ZM126.518 100.057H136.916C141.78 100.057 145.837 99.1705 149.087 97.3977C152.337 95.6023 154.78 92.9318 156.416 89.3864C158.053 85.8182 158.871 81.3636 158.871 76.0227C158.871 70.6818 158.053 66.25 156.416 62.7273C154.78 59.1818 152.359 56.5341 149.155 54.7841C145.973 53.0114 142.018 52.125 137.291 52.125H126.518V100.057ZM183.433 111V41.1818H228.161V51.7841H196.081V70.7386H225.092V81.3409H196.081V111H183.433Z",
    fill: "#FAFAFD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.821 178H226.179C243.857 178 258 192.143 258 209.821V319.75C258 337.429 243.857 351.571 226.179 351.571H109.821C92.1429 351.571 78 337.429 78 319.75V209.821C78 192.143 92.1429 178 109.821 178Z",
    fill: "#FA0F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.641 278.287C214.284 269.609 191.463 273.145 185.999 273.787C177.963 266.073 172.499 256.752 170.57 253.537C173.463 244.859 175.391 236.18 175.713 226.859C175.713 218.823 172.499 210.145 163.499 210.145C160.284 210.145 157.391 212.073 155.784 214.645C151.927 221.395 153.534 234.895 159.641 248.716C156.106 258.68 152.891 268.323 143.891 285.359C134.57 289.216 114.963 298.216 113.356 307.859C112.713 310.752 113.677 313.645 115.927 315.895C118.177 317.823 121.07 318.787 123.963 318.787C135.856 318.787 147.427 302.395 155.463 288.573C162.213 286.323 172.82 283.109 183.427 281.18C195.963 292.109 206.891 293.716 212.677 293.716C220.391 293.716 223.284 290.502 224.249 287.609C225.856 284.395 224.891 280.859 222.641 278.287V278.287ZM214.606 283.752C214.284 286.002 211.391 288.252 206.249 286.966C200.141 285.359 194.677 282.466 189.856 278.609C194.034 277.966 203.356 277.002 210.106 278.287C212.677 278.93 215.249 280.537 214.606 283.752V283.752ZM160.927 217.537C161.57 216.573 162.534 215.93 163.499 215.93C166.391 215.93 167.034 219.466 167.034 222.359C166.713 229.109 165.427 235.859 163.177 242.287C158.356 229.43 159.32 220.43 160.927 217.537V217.537ZM160.284 279.895C162.856 274.752 166.391 265.752 167.677 261.895C170.57 266.716 175.391 272.502 177.963 275.073C177.963 275.395 167.999 277.323 160.284 279.895V279.895ZM141.32 292.752C133.927 304.966 126.213 312.68 122.034 312.68C121.391 312.68 120.749 312.359 120.106 312.037C119.141 311.395 118.82 310.43 119.141 309.145C120.106 304.645 128.463 298.537 141.32 292.752Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_368",
    x: 40.0898,
    y: 41.1836,
    width: 192.07,
    height: 85.8164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_368"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_368",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_368",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E27C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_368",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E27C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_106_368",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E27C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_106_368",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E27C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_106_368",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E27C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0F00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 173.571,
    fill: "white",
    transform: "translate(78 178)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.f2f2ddc0738e26346f644e778f62cd09.svg";
export { ForwardRef as ReactComponent };